// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paragraph-block[data-v-5a3a9ad3]{color:#4e4e4e}", ""]);
// Exports
module.exports = exports;
